import { render, staticRenderFns } from "./UseCase.vue?vue&type=template&id=5b7984b1&scoped=true&"
import script from "./UseCase.vue?vue&type=script&lang=js&"
export * from "./UseCase.vue?vue&type=script&lang=js&"
import style0 from "./UseCase.vue?vue&type=style&index=0&id=5b7984b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7984b1",
  null
  
)

export default component.exports